/** Angle par défaut du faire-part en mode 3D (légèrement ouvert) */
const CARD_FOLD_DEFAULT = Math.PI * 0.12;

/** Angle maximum d'ouverture du faire-part en mode 3D */
const CARD_FOLD_MAX = Math.PI * 0.55;

export { CARD_FOLD_DEFAULT, CARD_FOLD_MAX };
